import BasePopupHandler, { MAIN_BUTTON_ANCHORS, PopupMainButtonLocations } from './BasePopupHandler';
import GameObject from '../../../GameObject/GameObject';
import UIItem, { ITextData } from '../../../Prototype/UI/UIItem';
import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import { IUIButtonData } from '../../../Prototype/UI/BaseElements/UIButton';
import { TextAlignment } from '../../../Prototype/UI/TextAlignment';
import { PlatformActions } from '../../../State/Game/PlatformActions';
import { PopupID } from '../../../State/UI/PopupID';
import { UIActions } from '../../../State/UI/UIActions';
import { IElementLayout } from '../../../Prototype/UI/Element';

export default class ConfirmQuitGameHandler extends BasePopupHandler {
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CONFIRM_QUIT_GAME, uiSystem);
    }

    public createPopup(params?: any) {
        this.backgroundParams.layout.constrains = this.getBackgroundLayoutConstrains();
        this.submitBtnParams.text.textLocalizationKey = 'Confirm';
        this.submitBtnParams.text.style = this.getSubmitStyle();
        this.submitBtnParams.button.layout = this.getSubmitLayout();
        this.submitBtnParams.button.cacheKey = 'button_medium_red';
        this.submitBtnParams.background.layout.anchors = MAIN_BUTTON_ANCHORS[PopupMainButtonLocations.LEFT];
        this.submitBtnParams.onClick = () => PlatformActions.quitGame();
        this.closeBtnParams.onClick = () => UIActions.hidePopup(this.name);

        super.createPopup({
            buttons: [this.submitBtnParams, this.closeBtnParams],
            title: 'Quit',
        });

        this.createMainInfo();
    }

    private createMainInfo(): void {
        const text: GameObject<PIXI.Container> = UIItem.createText(this.textParams);
        this.background.addChild(text);
    }

    protected textParams: ITextData = {
        name: 'confirm_quit_game_text',
        textLocalizationKey: 'AreYouSure',
        layout: {
            anchors: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#8b3130',
            fontSize: '42px',
        },
        bounds: [650, 400],
        wordWrap: true,
        wordWrapWidth: 650,
    };

    private getSubmitStyle() {
        return {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '50px',
            stroke: '#761818',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        };
    }

    private getSubmitLayout(): IElementLayout {
        return {
            anchors: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [-2, 50, -2, 50],
            scale: [1, 1],
        };
    }

    private getBackgroundLayoutConstrains() {
        return {
            heightMax: 744 / 1.15,
            heightMin: 744 / 1.15,
            widthMax: 858 / 1.15,
            widthMin: 858 / 1.15,
        };
    }

    protected closeBtnParams: IUIButtonData = {
        name: 'popup_submit_button',
        text: {
            name: 'submit_txt',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            textLocalizationKey: 'Cancel',
            style: Game.style.getStyle('popup.green_btn'),
            align: TextAlignment.CENTER,
            bounds: [220, 130],
        },
        button: {
            name: 'submit_btn',
            layout: {
                anchors: [0.7, 0.817, 0.7, 1],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            cacheKey: 'button_medium_green',
        },
        buttonMode: true,
        onClick: this.onSubmit.bind(this),
    };
}
